const constants = {
  US_REGION: 'EN_US',
  UK_REGION: 'EN_UK',

  EN_US: 'MM/DD/YYYY',
  EN_UK: 'DD/MM/YYYY',

  DB_DATE_FORMAT: 'YYYY-MM-DD',

  US_LONG_DATE: 'dddd, MMMM DD, YYYY',

  MONTH_DAY: 'MMM DD',

  STATUS: {
    SUCCESS: 'success',
    ERROR: 'error',
    FAIL: 'fail',
    INVALID: 'invalid',
    LOADING: 'loading',
  },

  brand: {
    sandals: 's',
    beaches: 'b',
  },
};

export default constants;

export const US_REGION = constants.US_REGION;
export const UK_REGION = constants.UK_REGION;
export const EN_US = constants.EN_US;
export const EN_UK = constants.EN_UK;
export const DB_DATE_FORMAT = constants.DB_DATE_FORMAT;
export const US_LONG_DATE = constants.US_LONG_DATE;
export const MONTH_DAY = constants.MONTH_DAY;
export const STATUS = constants.STATUS;
export const brand = constants.brand;



// WEBPACK FOOTER //
// ./js/modules/constants.js